import { FunctionComponent } from 'react';
import { CompoundFilterProps } from './CompoundFilterProps';
import { FilterModalTextInput } from '../../../../sharedComponents/filter/FilterModal';
import { useOnChangeTextFilter } from '../../../../sharedComponents/filter/useOnChangeTextFilter';

export const DepartureToFilter: FunctionComponent<CompoundFilterProps & { expected: boolean }> = ({
    localFilters,
    setLocalFilters,
    expected,
}) => {
    const handleChange = useOnChangeTextFilter('departureToFilter', setLocalFilters);

    return (
        <FilterModalTextInput
            id="departure-to-filter"
            headerMessageId={
                expected
                    ? 'outboundOrderBook.compoundManagement.filter.departingToLocation'
                    : 'outboundOrderBook.compoundManagement.filter.departedToLocation'
            }
            inputAddon="rioglyph rioglyph-load"
            placeholderMessageId="outboundOrderBook.common.filter.enterLocation"
            isOptional
            value={localFilters.departureToFilter}
            onChange={handleChange}
        />
    );
};
